export const ADMIN_PORTAL_STORAGE_KEY = "adminPortalType";

export const setAdminPortalType = (adminType) => {
  if (adminType === "bxi" || adminType === "brand_world") {
    try {
      window.localStorage?.setItem(ADMIN_PORTAL_STORAGE_KEY, adminType);
    } catch (e) {}
  }
};

export const getAdminPortalType = () => {
  try {
    const value = window.localStorage?.getItem(ADMIN_PORTAL_STORAGE_KEY);
    return value === "bxi" || value === "brand_world" ? value : null;
  } catch (e) {
    return null;
  }
};

export const clearAdminPortalType = () => {
  try {
    window.localStorage?.removeItem(ADMIN_PORTAL_STORAGE_KEY);
  } catch (e) {}
};

/** Prefer API adminType, then login portal, then safe BW default. */
export const resolveAdminPortalType = (userAdminType, fallback = "brand_world") => {
  if (userAdminType === "bxi" || userAdminType === "brand_world") {
    return userAdminType;
  }
  const stored = getAdminPortalType();
  if (stored) return stored;
  return fallback;
};
